import { useNavigate, useParams } from "react-router-dom";
import Input, { FormState, required, submitForm, useTextInput } from "../../../../components/input";
import MTable from "../../../../components/mtable";
import { api } from "../../../../env";
import { useEffect, useState } from "react";
import Title from "../../../../components/Title";

export default function CreateSpark() {

    const [state, setState] = useState(FormState.CREATE)
    const navigate = useNavigate()
    const { id } = useParams()

    useEffect(() => {
        if (id) {
            api.get(`sparks/${id}`)
                .then(res => {
                    let spark = res.data
                    createForm.name._setValue(spark?.name ?? "")
                    createForm.displayName._setValue(spark?.displayName ?? "")
                    createForm.description._setValue(spark?.description ?? "")
                    createForm.contentId._setValue(spark?.contentId ?? "")
                    setState(FormState.UPDATE)
                })
                .catch(err => {
                    navigate('../../')
                })
        } 
    }, [id])

    const resourceMapper = {columns: [
        {
            label: "ID",
            value: (item) => item.id
        },
        {
            label: "Name",
            value: (item) => item.name
        },
        {
            label: "Type",
            value: (item) => item.type
        }
    ]}

    const createForm = {
        name: useTextInput("Internal Name", "visibility_off", [required]),
        displayName: useTextInput("Display Name", "label", [required]),
        description: useTextInput("Description", "description", []),
        contentId: useTextInput("Resource ID [Copy the ID from the table below]", "fingerprint", [required])
    }

    const handleCreate = () => {
        const sparkInfo = submitForm(createForm)
        if(!sparkInfo) return
        api.post('sparks', sparkInfo)
            .then(res => navigate('../..'))
            .catch(err => navigate('../..'))
    }

    const handleCancel = () => {
        navigate('../../')
    }

    const handleSave = () => {
        const sparkInfo = submitForm(createForm)
        if (!sparkInfo || !id) return
        const { contentId, ...body } = sparkInfo
        api.put(`sparks/${id}`, body)
            .then((res) => navigate('../../'))
            .catch((err) => navigate('../../'))
    }

    const handleResourceSelected = (selection) => {
        let resource = selection[0]
        if (!resource) createForm.contentId._setValue('')
        else createForm.contentId._setValue(resource.id)
    }

    return(<div className="standard-padding page-xl-centered showing">
        <Title className={'v-spacer-xs'}>{state == FormState.CREATE ? 'Create' : 'Update'} Spark</Title>
        <div className="card flex columns gap-xs">
            <Input state={createForm.name}/>
            <Input state={createForm.displayName}/>
            <Input state={createForm.description}/>
            <div className="flex gap-xs justify-end">
                {state == FormState.CREATE && <button className="solid-accent" onClick={handleCreate}>Create</button>}
                {state == FormState.UPDATE && <button className="solid" onClick={handleSave}>Save</button>}
            </div>
        </div>
        {state == FormState.CREATE && <>
            <p className="section-title-s vi-spacer-xxl v-spacer-m">Available Resources</p>
            <MTable path={'resources'} mapper={resourceMapper} selectable={{onChange: handleResourceSelected, multiple: false, cards: true}}/>
        </>}
    </div>)
}